import React from "react";

const ListNothing = ({ imgSrc, bodyText }) => {
  // ICNoFileList
  // 신청이력을 찾을 수 없습니다.
  return (
    <div className="nothing-box">
      <div>
        <img src={imgSrc} alt="" />
        <p>{bodyText}</p>
      </div>
    </div>
  );
};

export default ListNothing;
